export enum HttpContextBase {
  Client,
  Dpr,
  DprDetails,
  ProjectSetup,
  ProjectAdmin,
  Report,
  Shared,
  SharedCore,
  SharedFile,
  UserAdmin,
}
